var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOriginalText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91285 8.83867H10.0868M5.91285 8.83867L4.7998 11.2M5.91285 8.83867L7.5799 5.30193C7.71423 5.01694 7.7814 4.87445 7.8733 4.82942C7.95322 4.79026 8.04639 4.79026 8.12631 4.82942C8.21821 4.87445 8.28538 5.01694 8.41971 5.30193L10.0868 8.83867M10.0868 8.83867L11.1998 11.2",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59961 5.01343C1.59961 3.81865 1.59961 3.22126 1.83213 2.76492C2.03666 2.36351 2.36302 2.03715 2.76443 1.83262C3.22077 1.6001 3.81816 1.6001 5.01294 1.6001H10.9863C12.1811 1.6001 12.7784 1.6001 13.2348 1.83262C13.6362 2.03715 13.9626 2.36351 14.1671 2.76492C14.3996 3.22126 14.3996 3.81865 14.3996 5.01343V10.9868C14.3996 12.1815 14.3996 12.7789 14.1671 13.2353C13.9626 13.6367 13.6362 13.963 13.2348 14.1676C12.7784 14.4001 12.1811 14.4001 10.9863 14.4001H5.01294C3.81816 14.4001 3.22077 14.4001 2.76443 14.1676C2.36302 13.963 2.03666 13.6367 1.83213 13.2353C1.59961 12.7789 1.59961 12.1815 1.59961 10.9868V5.01343Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginalText);
export default __webpack_public_path__ + "static/media/originalText.5869e25a8350934708cfb97ea4672305.svg";
export { ForwardRef as ReactComponent };